<template>
  <v-app>
    <navbar v-if="token" />
    <!-- <navbarPublic v-if="!token && $route.path !== '/login'" /> -->

    <v-main 
      light
      style="background: #FFFFFF;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import firebase from "firebase/app";
  import "firebase/messaging";
  export default {
    components: {
      navbar: () => import(/* webpackPrefetch: true */ '@/components/navbar.vue'),
      // navbarPublic: () => import(/* webpackPrefetch: true */ '@/components/navbar-public.vue'),
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      token () {
        return this.$store.state.token
      },
      user () {
        return this.$store.state.user
      }
    },
    created() {
      const d = {}

      document.addEventListener ('mousedown', e => {
        const closestDialog = e.target.closest('.v-dialog.v-dialog--active')
        if (e.button === 0 && closestDialog != null && e.target.classList.contains('v-card__title')) { 
          d.el = closestDialog
          d.mouseStartX = e.clientX
          d.mouseStartY = e.clientY
          d.elStartX = d.el.getBoundingClientRect().left
          d.elStartY = d.el.getBoundingClientRect().top
          d.el.style.position = 'fixed'
          d.el.style.margin = 0
          d.oldTransition = d.el.style.transition
          d.el.style.transition = 'none'
        }
      })

      document.addEventListener ('mousemove', e => {
          if (d.el === undefined) return

          d.el.style.left = Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
          ) + 'px'
          d.el.style.top = Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
          ) + 'px'
      })

      document.addEventListener ('mouseup', () => {
          if (d.el === undefined) return
          d.el.style.transition = d.oldTransition
          d.el = undefined
      })

      setInterval(() => { 
        const dialog = document.querySelector('.v-dialog.v-dialog--active')
        if (dialog === null) return
        dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + 'px'
        dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + 'px'
      }, 100)
    },
    methods: {
      
    }
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
  }

  #content {
    padding: 0px;
  }
</style>